import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import {
    Button,
    InputText,
    Form,
    Snackbar,
    VSpacer
} from 'sm-react-components';
import Link from '../components/Link';
import CircularProgress from '@material-ui/core/CircularProgress';
import mixpanel from '../../infrastructure/mixpanel';
import * as routes from '../../infrastructure/routemap';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { Redirect } from 'react-router-dom';
import { SessionConsumer } from '../components/SessionProvider';

const styles = theme => ({
    snackbarRoot: {
        top: '-10%'
    }
});

class LoginContainer extends Component {
  state = {
      email: '',
      password: '',
      error: undefined,
      loading: undefined,
      success: undefined,
      openSnack: false
  };
  componentDidMount() {
      if (this.props.validation === 'succ') {
          this.setState({
              error: 'Congratulations! Your account has been activated',
              validation: 'success',
              openSnack: true
          });
      } else if (this.props.validation === 'err') {
          this.setState({
              error: 'There was a problem validating your account',
              openSnack: true
          });
      }
  }

  isEmpty = s => s === undefined || s.length === 0;

  handleChange = name => value => {
      this.setState({
          [name]: value
      });
  };

  render() {
      const {
          email,
          password,
          error,
          loading,
          success,
          validation,
          openSnack
      } = this.state;
      const { classes } = this.props;
      return (
          <React.Fragment>
              {success && <Redirect to={routes.console.root} />}
              <Snackbar
                  variant={validation === 'success' ? validation : 'error'}
                  open={openSnack}
                  onClose={() => this.setState({ openSnack: false })}
                  autoHideDuration={3000}
                  closeByClickAway
                  horizontal="center"
                  vertical="top"
                  message={error}
                  classes={{ anchorOriginTopCenter: classes.snackbarRoot }}
              />
              <Grid
                  container
                  direction="column"
                  justify="space-between"
                  style={{ height: '100%' }}
              >
                  <Grid item>
                      <Grid container direction="column">
                          <Grid item>
                              <Typography
                                  color="textSecondary"
                                  variant="h5"
                                  className={classes.SignInContainer}
                              >
                  Login
                              </Typography>
                          </Grid>
                          <Grid item>
                              <SessionConsumer>
                                  {({ login }) => {
                                      const handleLogin = async () => {
                                          const { email, password } = this.state;
                                          try {
                                              this.setState({ loading: true });
                                              await login(email, password);
                                              this.setState({ success: true });
                                              mixpanel.identify(email);
                                          } catch (error) {
                                              this.setState({
                                                  error: error.message,
                                                  loading: false,
                                                  openSnack: true
                                              });
                                          }
                                      };

                                      return (
                                          <Form
                                              lazyValidation
                                              onSubmit={handleLogin}
                                              direction="column"
                                          >
                                              <VSpacer className="form-ignore" />
                                              <InputText
                                                  id="email"
                                                  type="email"
                                                  label="Email"
                                                  value={email}
                                                  onChange={this.handleChange('email')}
                                                  margin="none"
                                                  validators={['required', 'email']}
                                              />
                                              <InputText
                                                  id="password"
                                                  type="password"
                                                  label="Password"
                                                  value={password}
                                                  onChange={this.handleChange('password')}
                                                  margin="none"
                                                  validators={['required']}
                                                  customValidator={text => {
                                                      if (text.length < 8) {
                                                          return 'Text must contain at least 8 characters';
                                                      }
                                                      return undefined;
                                                  }}
                                              />
                                              <VSpacer small className="form-ignore" />
                                              <VSpacer />
                                              {loading ? (
                                                  <CircularProgress
                                                      className={classes.center + ' form-ignore'}
                                                  />
                                              ) : (
                                                  <Button className={classes.fullWidth} type="submit">
                            Login
                                                  </Button>
                                              )}
                                          </Form>
                                      );
                                  }}
                              </SessionConsumer>
                          </Grid>
                      </Grid>
                  </Grid>
                  <VSpacer large />
                  <Grid item>
                      <Grid container justify="space-between">
                          <Grid item>
                              <Typography>
                                  <Link to={routes.register}>Register</Link>
                              </Typography>
                          </Grid>
                          <Grid item>
                              <Typography>
                                  <Link to={routes.resetPassword}>Forgot Password?</Link>
                              </Typography>
                          </Grid>
                      </Grid>
                  </Grid>
              </Grid>
          </React.Fragment>
      );
  }
}

export default withStyles(styles)(LoginContainer);
